import { faCalendar } from '@fortawesome/pro-regular-svg-icons';
import styled from 'styled-components';
import { tokens } from 'styles/tokens';

const calendarIconData = encodeURIComponent(`
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 ${faCalendar.icon[0]} ${faCalendar.icon[1]}"
        color="${tokens.text.link}"
    >
        <g>
            <path fill="currentColor" d="${faCalendar.icon[4]}"/>
        </g>
    </svg>
`);

const DateTimeWrapper = styled.div<{ $hasValue: boolean }>`
    display: inline;
    width: 100%;

    .k-widget k-datetimepicker {
        display: flex !important;
    }

    .k-select {
        opacity: 1 !important;
    }

    .k-link {
        opacity: 1 !important;
    }

    .k-icon.k-i-calendar {
        background: url('data:image/svg+xml;utf8,${calendarIconData}') no-repeat 50% 50%;
        margin-right: 5px;

        &::before {
            content: none;
        }
    }

    .k-input {
        width: 100%;
        font-size: 1.4rem;
    }

    .k-picker-wrap,
    .k-picker-wrap:hover {
        border-bottom: solid 1px ${tokens.border.default};
    }

    .k-picker-wrap.k-state-focused {
        border-bottom: solid 2px ${tokens.input.borderFocus};
    }

    span.k-dateinput {
        padding-left: 5px;
        background-color: ${tokens.background.subtle};

        input {
            background-color: ${tokens.background.subtle};
            color: ${({ $hasValue }) =>
                $hasValue ? tokens.text.primary : tokens.text.secondary} !important;
            border: 0;
            width: 100%;
            margin-right: 0.5rem;
        }
    }

    button.k-button {
        background-color: ${tokens.background.subtle};
    }
    button svg path {
        fill: ${tokens.text.primary};
    }
    button:disabled svg path {
        fill: ${tokens.text.secondary};
    }
`;

export { DateTimeWrapper };
